(function () {
	if (localStorage.getItem('isCookieDisclaimerDismiss') === 'true') {
		return;
	}

	const afterDismiss = () => {
		localStorage.setItem('isCookieDisclaimerDismiss', 'true');
	};

	const disclaimer = new IMS.Disclaimer({
		baseClass: 'cookie-disclaimer',
		textLabel: 'cookie_policy_text',
		dismissLabelKey: 'dismiss',
		linkTextLabel: 'cookie_policy_link_text',
		linkLabel: 'cookie_policy_link',
		afterDismiss,
	});

	$(document).ready(function () {
		disclaimer.init();
	});
})();
